import script from "./QuestionTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionTabs.vue?vue&type=script&setup=true&lang=js"

import "./QuestionTabs.vue?vue&type=style&index=0&id=7edc583c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7edc583c"]])

export default __exports__